import { DefaultTheme } from 'styled-components';

const colors = {
  dodgerBlue: '#359eff',
  indigo: '#4757c4',
  periwinkle: '#c5d0ff',
  linkWater: '#CBD2F2',
  brightPeriwinkle: '#d6deff',
  baliHai: '#8d9cb7',
  catskillWhite: '#f2f4f8',
  mystica: '#edf0f5',
  mischka: '#DFE1E6',
  geyser: '#dee2e9',
  silver: '#ccc',
  athensGray: '#DFE2E9',
  riverBed: '#4b5467',
  riverBed_O15: 'rgba(75, 84, 103, 0.15)',
  slateGray: '#758095',
};

const theme: DefaultTheme = {
  borderRadius: '0',
  colors: {
    primary: colors.indigo,
    referenceLogBg: colors.geyser,
    referenceUserLogBg: colors.periwinkle,
    balloon: colors.mystica,
    balloonWithMenu: colors.mischka,
    userBalloon: colors.brightPeriwinkle,
    userBalloonWithMenu: colors.linkWater,
    border: colors.silver,
    modalFooterBorder: colors.athensGray,
    profileIconBorder: colors.riverBed_O15,
    tenantIconBorder: colors.riverBed_O15,
    labelText: colors.slateGray,
    important: colors.dodgerBlue,
    panelBorder: colors.baliHai,
    settingBorder: colors.geyser,
  },
  mode: 'default',
};

export default theme;
